import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {addTranslations} from "../actions/TranslationActions";
import FlightsList from "./flights/FlightsList";
import IframeHelper from "../helpers/IframeHelper";
import AppliedFilterList from "./appliedFilters/AppliedFilterList";
import Logger from "../helpers/Logger";
import Loader from "../helpers/Loader";

class FlightsContainer extends Component {
    componentDidMount() {
        let translations = {};
        translations[DOMAIN] = JSON.parse(this.props.dataTranslations);
        this.props.addTranslations(translations);
    }

    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in FlightsContainer', error.toString());
    }

    componentDidUpdate() {
        IframeHelper.updateHeight(this.props.parameters.projectUrl);
    }

    renderList() {
        if (Loader.showLoader(this.props.flights)) {
            return null;
        }

        return (
            <React.Fragment>
                <AppliedFilterList/>
                <FlightsList/>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderList()}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addTranslations,
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        translations: state.TranslationsReducer,
        flights: state.FlightsReducer,
        parameters: state.ParametersReducer.parameters
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsContainer);

export const DOMAIN = 'flights';



// WEBPACK FOOTER //
// ./src/components/FlightsContainer.js